import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const divider: SxStyle = { borderStyle: 'dashed' };

export const inputWrapper: SxStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
};

export const label: SxStyle = {
  fontSize: (p) => p.typography.body3.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[700],
};
